import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DocumentAuditEvent } from '../accounting-lifecycle.model';
import { AuditTimelineComponent } from '../../shared/audit/audit-timeline.component';

@Component({
    selector: 'app-accounting-audit-timeline',
    standalone: true,
    imports: [AuditTimelineComponent],
    template: `<app-audit-timeline title="Activity Timeline" [events]="events"></app-audit-timeline>`,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountingAuditTimelineComponent {
    @Input() events: DocumentAuditEvent[] = [];
}
